/* Disc Golf Swag - gift card product page behaviour (sections/dgs-gift-card.liquid).
   Loaded only by that section. Adding to cart is NOT handled here: the form is
   a normal /cart/add form and assets/cart-drawer.js adds it and opens the
   drawer, like every other product. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function addDays(d, n) { var c = new Date(d.getFullYear(), d.getMonth(), d.getDate()); c.setDate(c.getDate() + n); return c; }
  function parseYmd(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  ready(function () {
    var root = document.querySelector('[data-dgc]');
    if (!root) return;
    var form = root.querySelector('.dgc__form');
    if (!form) return;

    /* ---- amount ------------------------------------------------------- */
    var variantInput = root.querySelector('[data-dgc-variant]');
    var priceEl = root.querySelector('[data-dgc-price]');
    var hintEl = root.querySelector('[data-dgc-hint]');
    var previewAmount = root.querySelector('[data-dgc-preview-amount]');
    var amounts = root.querySelectorAll('[data-dgc-amount]');

    function selectAmount(btn) {
      amounts.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      variantInput.value = btn.getAttribute('data-variant-id');
      if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
      if (previewAmount) previewAmount.textContent = btn.getAttribute('data-price-short');
      if (hintEl) hintEl.textContent = btn.getAttribute('data-hint') || '';
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    amounts.forEach(function (b) {
      b.addEventListener('click', function () { if (!b.disabled) selectAmount(b); });
    });

    /* Shopify's recipient validation errors come back as an object, which the
       shared cart-drawer handler prints as "[object Object]". Replace that
       one message, on this page only, with something a person can act on. */
    document.addEventListener('cart:add-error', function () {
      setTimeout(function () {
        var w = form.parentNode.querySelector('.warning');
        if (w && /object Object|invalid|90 days/i.test(w.textContent)) {
          w.textContent = 'Please check the recipient\u2019s email and the delivery date (up to 90 days ahead), then try again.';
        }
      }, 0);
    });

    /* ---- image switcher ------------------------------------------------ */
    var slides = root.querySelectorAll('[data-dgc-slide]');
    var thumbs = root.querySelectorAll('[data-dgc-thumb]');
    function showSlide(name) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-dgc-slide') !== name; });
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-dgc-thumb') === name ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-dgc-thumb')); });
    });

    /* ---- delivery / recipient ----------------------------------------- */
    var recipient = root.querySelector('[data-dgc-recipient]');
    if (!recipient) return; // not a Shopify gift card product: amounts only

    var radios = root.querySelectorAll('[data-dgc-deliver]');
    var rInputs = recipient.querySelectorAll('[data-dgc-r]');
    var emailInput = recipient.querySelector('[data-dgc-email]');
    var nameInput = recipient.querySelector('[data-dgc-name]');
    var msgInput = recipient.querySelector('[data-dgc-msg]');
    var countEl = recipient.querySelector('[data-dgc-count]');
    var offsetInput = recipient.querySelector('[data-dgc-offset]');
    var dateInput = recipient.querySelector('[data-dgc-date]');
    var chips = recipient.querySelectorAll('[data-dgc-when]');
    var tagMe = root.querySelector('[data-dgc-tag-me]');
    var tagThem = root.querySelector('[data-dgc-tag-them]');
    var pvName = root.querySelector('[data-dgc-preview-name]');
    var pvMsg = root.querySelector('[data-dgc-preview-msg]');
    var pvWhen = root.querySelector('[data-dgc-preview-when]');

    if (offsetInput) offsetInput.value = String(new Date().getTimezoneOffset());

    // Shopify accepts a send date from today up to 90 days out.
    var today = new Date();
    var maxDate = addDays(today, 90);
    if (dateInput) {
      dateInput.min = ymd(addDays(today, 1));
      dateInput.max = ymd(maxDate);
    }

    // "Christmas morning" only while Dec 25 is still ahead and inside the window.
    var xmas = new Date(today.getFullYear(), 11, 25);
    var xmasChip = recipient.querySelector('[data-dgc-when="xmas"]');
    var xmasOk = xmas > addDays(today, 0) && xmas <= maxDate;
    if (xmasChip) xmasChip.hidden = !xmasOk;

    var when = 'now';
    var sendingToThem = false;

    function fmtDate(s) {
      if (!s) return '';
      var d = parseYmd(s);
      return 'on the morning of ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    }

    function updatePreview() {
      if (tagMe) tagMe.hidden = sendingToThem;
      if (tagThem) tagThem.hidden = !sendingToThem;
      if (!sendingToThem) return;
      var n = (nameInput.value || '').trim();
      pvName.textContent = n || 'someone special';
      var m = (msgInput.value || '').trim();
      pvMsg.textContent = m ? '“' + m + '”' : '';
      pvMsg.hidden = !m;
      if (when === 'now') pvWhen.textContent = 'right after checkout';
      else pvWhen.textContent = fmtDate(dateInput.value) || 'on the day you pick';
    }

    function applyWhen() {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-dgc-when') === when ? 'true' : 'false'); });
      if (!dateInput) return;
      if (when === 'now') {
        dateInput.disabled = true;
        dateInput.required = false;
        dateInput.hidden = true;
      } else if (when === 'xmas') {
        dateInput.value = ymd(xmas);
        dateInput.disabled = !sendingToThem;
        dateInput.required = false;
        dateInput.hidden = true;
      } else {
        dateInput.disabled = !sendingToThem;
        dateInput.required = sendingToThem;
        dateInput.hidden = false;
        if (dateInput.value && (dateInput.value < dateInput.min || dateInput.value > dateInput.max)) dateInput.value = '';
      }
      updatePreview();
    }

    function applyDeliver() {
      var checked = root.querySelector('[data-dgc-deliver]:checked');
      sendingToThem = !!checked && checked.value === 'them';
      recipient.hidden = !sendingToThem;
      // Disabled inputs are never submitted, so a "send to me" purchase carries
      // no recipient properties at all.
      rInputs.forEach(function (i) { i.disabled = !sendingToThem; });
      emailInput.required = sendingToThem;
      applyWhen();
      if (sendingToThem && emailInput && !emailInput.value) {
        try { emailInput.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', applyDeliver); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        when = c.getAttribute('data-dgc-when');
        applyWhen();
        if (when === 'pick' && dateInput) {
          try { dateInput.focus(); if (dateInput.showPicker) dateInput.showPicker(); } catch (e) {}
        }
      });
    });
    if (dateInput) dateInput.addEventListener('change', updatePreview);
    if (nameInput) nameInput.addEventListener('input', updatePreview);
    if (msgInput) {
      msgInput.addEventListener('input', function () {
        if (countEl) countEl.textContent = msgInput.value.length + ' / 200';
        updatePreview();
      });
    }

    // Browsers that ignore min/max on a date input (or a typed date) still get
    // a clear message instead of a Shopify error after the add.
    if (dateInput) {
      dateInput.addEventListener('input', function () {
        var v = dateInput.value;
        if (v && (v < dateInput.min || v > dateInput.max)) {
          dateInput.setCustomValidity('Pick a date between tomorrow and ' + MONTHS[maxDate.getMonth()] + ' ' + maxDate.getDate() + '.');
        } else {
          dateInput.setCustomValidity('');
        }
      });
    }

    applyDeliver();
  });
})();
